import React from 'react'

import Cross from './icons/Cross'

export interface ToggleProps {
  isOpen: boolean
  onClick: () => void
}

const Toggle: React.FC<ToggleProps> = ({ isOpen, onClick }) => {
  const rotation = isOpen ? 'rotate-45' : ''

  return (
    <button
      className={`group w-10 h-10 md:w-16 md:h-16 rounded-full bg-green flex items-center justify-center ${rotation} transition-transform duration-200 cursor-pointer z-20`}
      onClick={onClick}
    >
      <span className="sr-only">Toggle</span>
      <Cross className="transition duration-300 group-hover:scale-125" />
    </button>
  )
}

export default Toggle
